import { useTranslation } from 'react-i18next';
import { Chip, SxProps, Theme } from '@mui/material';
import { RecipeDataCompleteness } from '../../../mocks/data/demoRecipeTypes';

interface DataCompletenessChipProps {
  completeness?: RecipeDataCompleteness;
  sx?: SxProps<Theme>;
}

/** Flags a recipe (or a menu dish/row resolved from one) that only exists as a lightweight
 * catalogue summary rather than a fully authored recipe record - renders nothing for fully
 * authored recipes (dataCompleteness undefined or 'full') so existing rows are unaffected. */
const DataCompletenessChip = ({ completeness, sx }: DataCompletenessChipProps) => {
  const { t } = useTranslation('recipeV2');
  if (completeness !== 'summary') return null;

  return (
    <Chip
      label={t('dataCompleteness.summary', 'Catalogue summary')}
      color="warning"
      variant="outlined"
      size="small"
      sx={sx}
    />
  );
};

export default DataCompletenessChip;
